import { request } from '@/utils/request'

export function getInfo () {
  return request({
    url: '/rest/user/info',
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/rest/user.js